import type { ColorByRule } from 'components/color-by-attribute-modal';
import { resolveWellColor } from './resolve';
import {
  WELLBORE_GEOMETRY_KINDS,
  type WellboreGeometryKind,
} from './geometry-kinds';

export type TraceColors = Partial<Record<WellboreGeometryKind, string>>;

/**
 * What each kind of trace should draw in, for one well on one surface.
 *
 * A rule on the well's own fields matches the well, so every kind comes back the same
 * colour. A Wellbore Geometry rule matches the trace, so the kinds differ. Resolved once
 * per well, not per trace, so a map with many bores runs the rule stack once.
 * @param {ColorByRule[]} rules The rail's rules.
 * @param {string} target The surface asking.
 * @param {Record<string, string | null | undefined>} attributes The well's own values.
 * @return {TraceColors} A colour per trace kind, absent where no rule applies.
 */
export const resolveTraceColors = (
  rules: ColorByRule[],
  target: string,
  attributes: Record<string, string | null | undefined>
): TraceColors => {
  const colors: TraceColors = {};

  (Object.keys(WELLBORE_GEOMETRY_KINDS) as WellboreGeometryKind[]).forEach(
    (kind) => {
      const color = resolveWellColor(rules, target, {
        ...attributes,
        wellboreGeometry: kind,
      });
      if (color) colors[kind] = color;
    }
  );

  return colors;
};
